import { render, staticRenderFns } from "./role_permission.vue?vue&type=template&id=081d0d6e"
import script from "./role_permission.vue?vue&type=script&lang=js"
export * from "./role_permission.vue?vue&type=script&lang=js"
import style0 from "./role_permission.vue?vue&type=style&index=0&id=081d0d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports